<!-- Need to determine if the page is on a Mobile screen or not. There are various changes for Mobile, Logged In and Logged Out user -->
<template>

  <!-- Rewards to be redeemed Panel -->
  <div v-if="$variable('customer.loggedIn') && claimedRewards.length > 0" class="claimed-rewards-container" id="start-earning"
    :style="isMobile ? {'background-color': '#fcfaff !important'} : {'background-color': '#F8F4EC !important'}">
    <HighlighterTitle
        :class="`section-title`"
        :highlighter-copy="`Rewards ready to redeem`"
        :highlighter-size="`h2`"
        :highlighter-color="`accent03`"
      />
    <div class="follow-us-container">
      <div
       v-for="reward in claimedRewards.filter(r => r.redeemable?.used_at === null).sort((r1,r2)=>r1.point_cost-r2.point_cost)"
       class="social-box reward-card">
        <!-- Voucher Title -->
        <h3>{{ reward.reward.title }}</h3>
        <!-- Voucher Code -->
        <h3>{{ reward.redeemable.code }}</h3>
      </div>
    </div>

  </div>

  <!-- Start earning points Panel -->
  <div class="follow-us-refer-container" id="start-earning" >
    <HighlighterTitle
        :class="`section-title`"
        :highlighter-copy="liquid.panel_title"
        :highlighter-size="`h2`"
        :highlighter-color="`accent03`"
      />
    <div class="follow-us-container">
      <div class="social-box">
        <div class="social-icon purchase-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          :url="`https://www.dormify.com/collections/bestsellers`"
          :label="`MAKE A PURCHASE →`"
          :icon="false"
          :custom-element="'a'"
        />
        <div v-if="!isMobile" class="title">MAKE A PURCHASE</div>
        <div class="subtitle">5 points PER $1*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          :url="`https://www.dormify.com/collections/bestsellers`"
          :label="`Shop Now`"
          :custom-element="'a'"
        />
      </div>
      <div class="social-box">
        <div class="social-icon heart-icon"></div>
        <a data-lion-refer>
          <Btn
            v-if="isMobile"
            :class="`btn-title`"
            :modifiers="[`outlined`]"
            :url="``"
            :label="`REFER A FRIEND →`"
            :icon="false"
            :disabled="!$variable('customer.loggedIn')"
          />
        </a>
        <div v-if="!isMobile" class="title">REFER A FRIEND</div>
        <div class="subtitle">1500-2500 points*</div>
        <a data-lion-refer>
          <Btn
            v-if="!isMobile"
            :class="`btn`"
            :modifiers="[`outlined`]"
            :url="``"
            :label="`Share the love`"
            :disabled="!$variable('customer.loggedIn')"
          />
        </a>
      </div>
      <div class="social-box">
        <div class="social-icon chat-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          :url="`https://www.dormify.com/pages/rewards-email-sms-sign-up`"
          :label="`SIGN UP FOR TEXTS →`"
          :icon="false"
          :custom-element="'a'"
        />
        <div v-if="!isMobile" class="title">SIGN UP FOR TEXTS</div>
        <div class="subtitle">+70 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          :url="`https://www.dormify.com/pages/rewards-email-sms-sign-up`"
          :label="`Sign up`"
          :custom-element="'a'"
        />
      </div>
      <div class="social-box">
        <div class="social-icon mail-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          @click="redirectToAttentive()"
          :label="$variable('customer.loggedIn') ? 'Completed' : `SIGN UP FOR EMAIL →`"
          :icon="false"
          :disabled="$variable('customer.loggedIn')"
        />
        <div v-if="!isMobile" class="title">SIGN UP FOR EMAIL</div>
        <div class="subtitle">+30 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          @click="redirectToAttentive()"
          :label="$variable('customer.loggedIn') ? 'Completed' : `Sign Up`"
          :disabled="$variable('customer.loggedIn')"
        />
      </div>
      <div class="social-box">
        <div class="social-icon star-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          :label="`LEAVE A REVIEW →`"
          :icon="false"
          @click="lionRuleItemClick(`review`)"
          :disabled="!$variable('customer.loggedIn')"
        />
        <div v-if="!isMobile" class="title">LEAVE A REVIEW</div>
        <div class="subtitle">+250 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          :label="`Learn More`"
          @click="lionRuleItemClick(`review`)"
          :disabled="!$variable('customer.loggedIn')"
        />
      </div>
      <div class="social-box">
        <div class="social-icon birthday-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          :label="`HAPPY BIRTHDAY →`"
          :icon="false"
          @click="lionRuleItemClick(`Birthday`)"
          :disabled="!$variable('customer.loggedIn') || !birthdayText.includes('Celebrate')"
        />
        <div v-if="!isMobile" class="title">HAPPY BIRTHDAY</div>
        <div class="subtitle">500-1500 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          :label="birthdayText"
          @click="lionRuleItemClick(`Birthday`)"
          :disabled="!$variable('customer.loggedIn') || !birthdayText.includes('Celebrate')"
          :icon="birthdayText.includes('Celebrate') ? 'direction.arrow.right' : false"
        />
      </div>
      <div class="social-box">
        <div class="social-icon tiktok-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          @click="lionRuleItemClick(`TikTok`)"
          :label="isTiktokCompleted ? `Completed` : `FOLLOW US ON TIKTOK →`"
          :disabled="!$variable('customer.loggedIn') ? true : isTiktokCompleted"
          :icon="false"
        />
        <div v-if="!isMobile" class="title">FOLLOW US<br>ON TIKTOK</div>
        <div class="subtitle">+40 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          @click="lionRuleItemClick(`TikTok`)"
          :label="isTiktokCompleted ? `Completed` : 'Follow us'"
          :disabled="!$variable('customer.loggedIn') ? true : isTiktokCompleted"
          :icon="isTiktokCompleted ? false : 'direction.arrow.right'"
        />
      </div>
      <div class="social-box">
        <div class="social-icon pinterest-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          @click="lionRuleItemClick(`Pinterest`)"
          :label="isPinterestCompleted ? `Completed` : `FOLLOW US ON PINTEREST →`"
          :disabled="!$variable('customer.loggedIn') ? true : isPinterestCompleted"
          :icon="false"
        />
        <div v-if="!isMobile" class="title">FOLLOW US ON<br>PINTEREST</div>
        <div class="subtitle">+40 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          @click="lionRuleItemClick(`Pinterest`)"
          :label="isPinterestCompleted ? `Completed` : 'Follow us'"
          :disabled="!$variable('customer.loggedIn') ? true : isPinterestCompleted"
          :icon="isPinterestCompleted ? false : 'direction.arrow.right'"
        />
      </div>
      <div class="social-box">
        <div class="social-icon facebook-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          :label="isFacebookCompleted ? `Completed` : `LIKE US ON FACEBOOK →`"
          :icon="false"
          @click="lionRuleItemClick(`Facebook`)"
          :disabled="!$variable('customer.loggedIn') ? true : isFacebookCompleted"
        />
        <div v-if="!isMobile" class="title">LIKE US ON<br>FACEBOOK</div>
        <div class="subtitle">+25 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          :label="isFacebookCompleted ? `Completed` : 'Like us'"
          @click="lionRuleItemClick(`Facebook`)"
          :disabled="!$variable('customer.loggedIn') ? true : isFacebookCompleted"
          :icon="isFacebookCompleted ? false : 'direction.arrow.right'"
        />
      </div>
      <div class="social-box">
        <div class="social-icon instagram-icon"></div>
        <Btn
          v-if="isMobile"
          :class="`btn-title`"
          :modifiers="[`outlined`]"
          :label="isInstagramCompleted ? `Completed` : `FOLLOW US ON INSTAGRAM →`"
          :icon="false"
          @click="lionRuleItemClick(`Instagram`)"
          :disabled="!$variable('customer.loggedIn') ? true : isInstagramCompleted"
        />
        <div v-if="!isMobile" class="title">FOLLOW US ON<br>INSTAGRAM</div>
        <div class="subtitle">+25 points*</div>
        <Btn
          v-if="!isMobile"
          :class="`btn`"
          :modifiers="[`outlined`]"
          :label="isInstagramCompleted ? `Completed` : 'Follow us'"
          @click="lionRuleItemClick(`Instagram`)"
          :disabled="!$variable('customer.loggedIn') ? true : isInstagramCompleted"
          :icon="isInstagramCompleted ? false : 'direction.arrow.right'"
        />
      </div>
    </div>

  </div>

</template>

<script>

import { mapState, mapActions } from 'vuex'
import HighlighterTitle from '~global/highlighter-title/highlighter-title'
import Btn from '~global/btn/btn'

export default {
  name: 'LoyaltyLion',
  components: {
    HighlighterTitle,
    Btn
  },

  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: () => ({
        panel_title: '',
      }),
    }
  },

  data() {
    return {
      tierName: '',
      customerPoints: loyaltylion.customer?.pointsTotal || 0,
      isPinterestCompleted: false,
      isTiktokCompleted: false,
      isFacebookCompleted: false,
      isInstagramCompleted: false,
      birthdayText: 'Celebrate',
      claimedRewards: [],
    }
  },

  computed: {

    /**
     * Map Vuex state.
    */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

  },

  mounted() {

    this.setComponentState({ handle: 'loyalty-lion-content', state: 'active' })

    // Here we will get the data of the client, also check if the page is on a Mobile screen or not
    // When using these variables in the HTML over the <script> part (within Vue component, not the liquid file), we use them without the prefix "this."
    console.log('customer', this.$variable('customer'));
    console.log('customer.loggedIn', this.$variable('customer.loggedIn')); // v-if="$variable('customer.loggedIn') && !isMobile"
    console.log('customer.firstName', this.$variable('customer.firstName')); // gets the first name
    // This will let you know if it's mobile, or not
    // Comments can be deleted as you see fit
    console.log('isMobile?', this.isMobile);

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const navElement = document.getElementById("shopify-section-site-header");
          const navbarHeight = navElement.getBoundingClientRect().height;
          const offset = targetElement.getBoundingClientRect().top - navbarHeight;

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          window.scrollTo({
            top: offset + scrollTop,
            behavior: 'smooth'
          });
        }
      });
    });

    // Amount of Points
    // The Tier the Customer is in
    if(!this.customer) return; // There is no customer

    const tier = this.customer.find(t => t.includes('tier'));
    this.tierName = tier ? tier.split('tier: ')[1] : 'Honor Roll';

    // These are the Tier Name and the Customer Points
    console.log('Tier name is:', this.tierName);

    // Observer for Rewards Summary modal
    const observer = new MutationObserver((mutationList, observer)=>{
      this.updatePoints();
      setTimeout(()=>{
        const rewardsSummary = document.getElementsByClassName('lion-redeem-reward-modal__summary')[0];
        if(rewardsSummary){
          rewardsSummary.innerText = rewardsSummary.innerText.replace('All your rewards can be viewed anytime on this page.','You can use this at checkout on your next Dormify Purchase!');
        }

        const leaveAReviewText = document.getElementsByClassName('lion-action-modal__description')[0];
        if(leaveAReviewText && leaveAReviewText.innerText.includes('Automatically')){
          leaveAReviewText.innerText = leaveAReviewText.innerText.replace('Automatically get 250 points when you leave us a review!','Get 250 points when you leave us a product review after your purchase');
        }
      }, 30)
    })

    const rulesObserver = new MutationObserver((mutations, observer)=>{
      this.updatePoints();
      setTimeout(()=>{
        this.getRulesElements();
      },250)
    })

    const config = { attributes: true, childList: true, subtree: true };

    let count = 0;
    const intervalId = setInterval(()=>{
      const loyaltyPanel = document.getElementById('loyaltylion');
      if(loyaltyPanel && loyaltylion.customer){

        this.getRulesElements();

        const loyaltyPanel = document.getElementById('loyaltylion');
        const loyaltyModalPanel = document.getElementById('lion-loyalty-panel-custom-css');
        const rulesPanel = document.getElementsByClassName('lion-rules-list')[0];
        if(loyaltyPanel){
          observer.observe(loyaltyPanel, config);
          observer.observe(loyaltyModalPanel, config);
          rulesObserver.observe(rulesPanel, config);
        }

        this.customerPoints = loyaltylion.customer.pointsTotal;
        this.claimedRewards = loyaltylion.customer.claimedRewards.filter(r => r.state === 'approved' && r.redeemable?.used_at === null);

        clearInterval(intervalId);
      }else{
        count = count+1;
      }
      if(count > 50){
        clearInterval(intervalId);
      }
    },250)
  },

  methods: {

    /**
     * Map Vuex actions.
    */
    ...mapActions({
      setComponentState: 'components/setState',
    }),

    lionRuleItemClick(keyWordTitle){
      this.customActionsPerKeyworkTitle(keyWordTitle);
      const container = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                      .find(o=>o.innerText.includes(keyWordTitle))?.nextSibling?.nextSibling;
      console.log("container is: ", container)
      const element = container.getElementsByClassName("lion-action-button")?.[0];
      console.log("element is: ", element)
      element.click()
    },

    getRulesElements(){
      const pinterestElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                      .find(o=>o.innerText.includes('Pinterest'))?.nextSibling?.nextSibling?.children[0];

      const tiktokElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                    .find(o=>o.innerText.includes('TikTok'))?.nextSibling?.nextSibling?.children[0];

      const birthdayElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                   .find(o=>o.innerText.includes('Birthday'))?.nextSibling?.nextSibling?.children[0];
      const facebookElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                    .find(o=>o.innerText.includes('Facebook'))?.nextSibling?.nextSibling?.children[0];

      const instagramElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                    .find(o=>o.innerText.includes('Instagram'))?.nextSibling?.nextSibling?.children[0];


      if(pinterestElement && pinterestElement.innerText === 'Completed') this.isPinterestCompleted = true;
      if(tiktokElement && tiktokElement.innerText === 'Completed') this.isTiktokCompleted = true;
      if(birthdayElement && !birthdayElement.innerText.includes('birthday')) this.birthdayText = birthdayElement.innerText;
      if(facebookElement && facebookElement?.innerText === 'Completed') this.isFacebookCompleted = true;
      if(instagramElement && instagramElement?.innerText === 'Completed') this.isInstagramCompleted = true;
    },

    customActionsPerKeyworkTitle(keyWordTitle){
      // Because LoyaltyLion's response takes a LOT of time, we immediatly show the user the completed
      // and once he reloads the page, he'll see what Loyalty Lion sends
      if(keyWordTitle === 'Pinterest'){
        this.isPinterestCompleted = true;
      }
      else if(keyWordTitle === 'TikTok'){
        this.isTiktokCompleted = true;
      }
      else if(keyWordTitle === 'Facebook'){
        this.isFacebookCompleted = true;
      }
      else if(keyWordTitle === 'Instagram'){
        this.isInstagramCompleted = true;
      }
    },

    updatePoints(){
      if(loyaltylion?.customer){
        this.customerPoints = loyaltylion.customer.pointsTotal;
      }
    },

    redirectToAttentive(){
      window.location = `https://www.dormify.com/pages/rewards-email-sms-sign-up`
    }

  },
}
</script>

<style lang="scss">
@import './loyalty-lion-content';
</style>
